import axios from "axios";
import {WMSCapabilities} from "ol/format";

const baseUrl = '/api/single/layer';

export const getLayerBreadcrumb = (id) => axios.get(`${baseUrl}/breadcrumb/${id}`)
export const getLayerData = (id) => axios.get(`${baseUrl}/data/${id}`)
export const getLayerStory = (id) => axios.get(`${baseUrl}/story/${id}`)

export function getLayerColorMaps(workspace, layerName) {
    const url = (window.__env__?.REACT_APP_GEO_SERVER_BASE_URL ?? process.env.REACT_APP_GEO_SERVER_BASE_URL) + `/${workspace}/${layerName}/ows?service=WMS&request=GetCapabilities`
    // const url = process.env.REACT_APP_GEO_SERVER_BASE_URL + `/${workspace}/wms?service=WMS&version=1.1.1&outputFormat=application/json&request=GetCapabilities&layers=${workspace}:${layerName}`

    return axios.get(url).then((response) => {
        const parser = new WMSCapabilities();
        const result = parser.read(response.data);
        const styles = result['Capability']['Layer']['Layer'][0]['Style']
        return styles.map((style) => style['Name'])
    });
}

export function getLayerFromGroup(workspace, layerGroupName) {
    const url = (window.__env__?.REACT_APP_GEO_SERVER_BASE_URL ?? process.env.REACT_APP_GEO_SERVER_BASE_URL) + `/${workspace}/wms` +
        '?service=WMS' +
        '&version=1.1.1' +
        '&outputFormat=application/json' +
        '&request=DescribeLayer' +
        `&layers=${workspace}:${layerGroupName}`

    return axios.get(url).then((response) => {
        const result = []
        const {layerDescriptions} = response.data

        layerDescriptions.forEach((layer) => {
            let {layerName} = layer
            const date = layerName.split("_")[1]
            layerName = layerName.split(":")[1]

            result.push({
                layerName,
                date
            })
        })

        return result;
    });
}


export function getLayerLegend(layer, colorMap) {
    const url = (window.__env__?.REACT_APP_GEO_SERVER_BASE_URL ?? process.env.REACT_APP_GEO_SERVER_BASE_URL) + '/wms' +
        '?REQUEST=GetLegendGraphic' +
        '&VERSION=1.0.0' +
        '&FORMAT=application/json' +
        `&LAYER=${layer}` +
        `&STYLE=${colorMap}`

    return axios.get(url)
}
